var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarEventLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.647,
    height: 19.647,
    viewBox: "0 0 19.647 19.647",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "calendar-event-line",
    d: "M8.877,1V2.965h5.894V1h1.965V2.965h3.929a.982.982,0,0,1,.982.982V19.665a.982.982,0,0,1-.982.982H2.982A.982.982,0,0,1,2,19.665V3.947a.982.982,0,0,1,.982-.982H6.912V1Zm10.806,9.824H3.965v7.859H19.683Zm-8.841,1.965v3.929H5.929V12.788ZM6.912,4.929H3.965V8.859H19.683V4.929H16.736V6.894H14.771V4.929H8.877V6.894H6.912Z",
    transform: "translate(-2 -1)",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarEventLine);
export default __webpack_public_path__ + "static/media/calendar-event-line.822ee214a0c15c9c601e29c4bab01deb.svg";
export { ForwardRef as ReactComponent };